import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { CancellablePromise } from 'src/app/types/cancellable-promise';
// @ts-ignore
import { LngLatBounds } from '!mapbox-gl';
import { SLLayer, LayerTypeEnum } from '../sl-layer';
import { GeoService } from 'src/app/services/geo.service';
import { ViewContext } from 'src/app/types/view-context';
import { BBOXArray, ILayerApiService, ILayerOverlay, SearchParams, AnyHandler } from 'src/app/types/@types/sl-v-types';
import { Decorable } from 'src/app/types/decorable';
import { LayerOverlay } from '../layer-overlay';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { SaveLayerDialogService } from 'src/app/components/dialogs/save-layer-dialog/save-layer-dialog-service';
import { LoadLayerDialogService } from 'src/app/components/dialogs/load-layer-dialog/load-layer-dialog-service';
import { LabelStyleString } from 'src/app/types/LabelStyle';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { LngLat } from 'mapbox-gl';

export interface BufferInfo {
  buffer: number;
  gids: string;
  centerLat?: string;
  centerLon?: string;
  bufferBbox?: string;
  inputBbox?: string;
  inputType?: 'rect' | 'point';
}
export interface LayerSaveOptions {
  target: 'player' | 'layer';
  properties?: boolean;
  classification?: boolean;
  labelStyle?: boolean;
  tooltip_rich?: boolean;
  tooltip?: boolean;
  tooltipOn?: boolean;
}
export interface LayerLoadOptions {
  target: 'player' | 'layer';
  properties?: boolean;
  classification?: boolean;
  labelStyle?: boolean;
  tooltip_rich?: boolean;
  tooltip?: boolean;
  tooltipOn?: boolean;
}

export enum FormatOpts {
  BASIC = 1,
  OWNER = 2,
  LABELS = 4,
  DESCRIPTION = 8,
  TAGS = 16,
  CLASSIFICATION = 32,
  ATTRIBUTES = 64,
  EXTENT = 128,
  LEGEND = 256,
  SEARCHTIP = 512,
  TOOLTIP = 1024,
  TOOLTIP_RICH = 2048,
  ADDER = 4096,
  PROPERTIES = 8192,
  BOUNDS = 16384
}

@Injectable({
  providedIn: 'root'
})
export class LayerApiService implements ILayerApiService {
  static LayerFormatOpts = [
    FormatOpts.BASIC,
    FormatOpts.OWNER,
    FormatOpts.LABELS,
    FormatOpts.DESCRIPTION,
    FormatOpts.TAGS,
    FormatOpts.CLASSIFICATION,
    FormatOpts.ATTRIBUTES,
    FormatOpts.LEGEND,
    FormatOpts.SEARCHTIP,
    FormatOpts.TOOLTIP,
    FormatOpts.TOOLTIP_RICH
  ];
  static PLayerFormatOpts = [FormatOpts.ADDER, FormatOpts.PROPERTIES, FormatOpts.BOUNDS];
  private renderMode = 'layer';

  get empty(): string {
    return 'data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }
  set mode(renderMode: string) {
    this.renderMode = renderMode;
  }
  constructor(
    private wapi: SlWapiService,
    private geoService: GeoService,
    private saveDialogService: SaveLayerDialogService,
    private loadDialogService: LoadLayerDialogService,
    private modalMessager: ModalMessagerService
  ) {
    this.renderMode = this.renderMode;
  }

  LoadLayerById(layerId: number, map: ISLMap = null, asProjLayer: boolean = false): Promise<SLLayer> {
    return new Promise<SLLayer>((resolve, reject) => {
      this.wapi.Post('layers/layer/action:load/', asProjLayer ? { plid: layerId } : { layer: layerId }).then((reply: any) => {

        resolve(new SLLayer(reply.response.layer, map, this));
      }, (reason) => {
        reject(reason);
        return;

      });
    });
  }



  RenderProjectLayerById(
    lId: number | string | SLLayer,
    map: ISLMap,
    features: Array<any> = [],
    styles: any = null,
    labelOn: boolean = null,
    bufferInfo?: BufferInfo,
    labelStyle?: LabelStyleString,
    labelOverride?: string
  ): CancellablePromise {
    // const mapUI: Map = (map.ui as Map);

    const layer: SLLayer = (lId instanceof SLLayer) ? lId : map.GetLayerById('' + lId, true);
    lId = layer.renderId;
    if (labelOn === null) {
      labelOn = layer.labelsOn;
    }
    if ((!labelStyle || labelStyle === '') && !!styles?.labelStyle) {
      labelStyle = styles.labelStyle;
    }
    if ((!labelOverride || labelOverride === '') && !!styles?.labelOverride) {
      labelOverride = styles.labelOverride;
    }
    if (!!layer.filterIds && features.length === 0) {
      features = layer.filterIds as Array<any>;

    }
    const featureField = layer.filterField;
    const viewContext: ViewContext = map.currentViewState;

    const [adjWidth, adjHeight] = map.GetPitchedViewSize(viewContext);
    const bounds: LngLatBounds = map.GetPitchedMapExtent(viewContext, [adjWidth, adjHeight]);
    const bboxBounds: BBOXArray = map.MapExtentToBBoxArray(bounds);
    const bbox = [];
    let ctr = -1;
    for (const val of bboxBounds) {
      ctr++;
      // if (ctr % 2 === 0) {
      // 	bbox.push(val + 360);
      // } else {
      bbox.push(val);
      // }
    }
    const params: any = {
      player_id: lId,
      project: map.project.id,
      width: adjWidth,
      height: adjHeight,
      bbox: (bbox),
      labels: labelOn ? '1' : '0',
      maptype: 'web',
      base64: true
    };
    if (layer.IsVirtual(Number(lId))) {
      if (layer.exclusions.HasExclusions()) {
        styles = undefined;
      }
    } else {
      layer.exclusions.Decorate(params, 'excluded_classes');
    }
    if (labelOn === true) {
      if (!!labelOverride && labelOverride !== '') {
        params.label = labelOverride;
      } else {
        if (layer.labelAttribute !== '_sl_override_') {
          params.label_field = layer.labelAttribute;
        } else {
          params.labels = 0;
        }
      }
    }
    if (!!labelStyle && (labelStyle !== '')) {
      params.labelStyle = labelStyle;
    }
    if (features.length === 0) {
      if (layer.filterIds !== null) {
        switch (typeof layer.filterIds) {
          case 'string':
            params.gids = layer.filterIds
            break;
          case 'object':
            params.gids = layer.filterIds.join(',');
            break;
        }

      }
    }
    if (features.length > 0) {
      params.gids = features.join(',');
      if (!!featureField) {
        params.filter_field = featureField;
      }
    }
    if (styles) {

      if (styles.hasOwnProperty('selected')) {
        if (styles.selected.indexOf('inherit') === -1) {
          params.color = styles.selected;
        } else {
          params.color = 'inherit';
        }
      } else {
        params.color = 'inherit';
      }

      if (styles.hasOwnProperty('unselected')) {
        if (styles.unselected !== 'trans') {
          if (styles.unselected.indexOf('inherit') === -1) {
            params.uncolor = styles.unselected;
          } else {
            params.uncolor = 'inherit';
          }
        }
      }
      if (styles.hasOwnProperty('unnormal')) {
        if (styles.unnormal.indexOf('inherit') === -1) {
          params.unnormal = styles.unnormal;
        } else {
          params.unnormal = 'inherit';
        }
      }
      if (styles.hasOwnProperty('criteria')) {
        params.criteria = styles.criteria;
      }

    } else {
      params.color = 'trans';
      params.opacity = '0';
    }
    if (!!bufferInfo) {
      if (bufferInfo.buffer !== null) {
        params.buffer = bufferInfo.buffer;
      }
      if (bufferInfo.gids !== null) {
        params.gids = bufferInfo.gids;
      }
      if (!!bufferInfo.centerLat) {
        params.centerLat = bufferInfo.centerLat;
      }
      if (!!bufferInfo.centerLon) {
        params.centerLon = bufferInfo.centerLon;
      }
      if (!!bufferInfo.bufferBbox) {
        params.bufferBbox = bufferInfo.bufferBbox;
      }
      if (!!bufferInfo.inputBbox) {
        params.inputBbox = bufferInfo.inputBbox;
      }
      if (!!bufferInfo.inputType) {
        params.inputType = bufferInfo.inputType;
      }
    }
    return this.wapi.Post('layers/render', params, false);
  }

  RenderLayerById(
    lId: number | string | SLLayer,
    map: ISLMap, features: Array<any> = [], styles: any, labelOn: boolean = null, labelStyle?: LabelStyleString
  ): CancellablePromise | void {

    // const mapUI: Map = (map.ui as Map);
    const layer: SLLayer = (lId instanceof SLLayer) ? lId : map.GetLayerById('' + lId, false);
    if (layer.layerOn === false) {
      return;
    }


    if (labelOn === null) {
      labelOn = layer.labelsOn;
    }
    if ((!labelStyle || labelStyle === '') && !!styles?.labelStyle) {
      labelStyle = styles.labelStyle;
    }
    if (!!layer.filterIds && features.length === 0) {
      features = layer.filterIds as Array<any>;
    }
    lId = layer.renderId;
    const viewContext: ViewContext = map.currentViewState;
    const [adjWidth, adjHeight] = map.GetPitchedViewSize(viewContext);
    const bounds: LngLatBounds = map.GetPitchedMapExtent(viewContext, [adjWidth, adjHeight]);
    let ctr = -1;
    const bbox: BBOXArray = map.MapExtentToBBoxArray(bounds);
    for (const val of bbox) {
      ctr++;
      // if (ctr % 2 === 0) {
      //	bbox.push(val + 360);
      // } else {
      bbox.push(val);
      // }
    }
    // const bounds: LngLatBounds = map.GetPitchedMapExtent(viewContext);
    // const [adjWidth, adjHeight] = map.GetPitchedViewSize(viewContext);

    /*return this.wapi.Post('layers/render',
      {
        layerId: lId,
        width: adjWidth,
        height: adjHeight,
        bbox: this.geoService.LngLatBoundsToBBoxString(bounds),
        maptype: 'web',
        base64: true
      }, false);*/
    const params: any = {
      layer_id: lId,
      width: viewContext.position.width,
      height: viewContext.position.height,
      bbox: viewContext.bbox,
      labels: layer.labelsOn ? '1' : '0',
      maptype: 'web',
      base64: true
    };
    if (layer.exclusions.IsExcluded(layer.constructor.name.toLowerCase())) {
      params.opacity = 0;
    }
    if (layer.labelAttribute !== '') {
      params.label_field = layer.labelAttribute;
    }

    if (labelOn === true) {
      if (!!labelStyle) {
        params.labelStyle = labelStyle;
      }
    }
    if (features.length > 0) {
      params.gids = features.join(',');
      params.unnormal = 0;
      if (styles.hasOwnProperty('selected')) {
        params.color = styles.selected;
      }
      if (styles.hasOwnProperty('unselected')) {
        params.uncolor = styles.unselected;
      }
      if (styles.hasOwnProperty('unnormal')) {
        params.unnormal = styles.unnormal;
      }
    }

    return this.wapi.Post('layers/render',
      params, false);

  }
  LayerExtsToLngLatBounds(layerExts: BBOXArray): LngLatBounds {
    return this.geoService.BBoxToLngLatBounds(layerExts) as LngLatBounds;
  }
  GetVirtualSwatch(layer: SLLayer, iconWidth: number = 60, iconHeight: number = 21) {
    return new Promise<any>((resolve, reject) => {

      const args: Decorable = {
        project: layer.map.project.id
      };

      switch (layer.inputType) {
        case 'point':
          args.geomtype = 'point';

          break;
        case 'rect':
          args.geomtype = 'polygon';

          break;
        default:
          args.geomtype = layer.geom.toLowerCase();


      }
      let hilight = '1';
      const legendLayer = layer as SLLayer & { GetLegendDescription?: () => string };
      args.description = typeof legendLayer.GetLegendDescription === 'function' ?
        legendLayer.GetLegendDescription() :
        '';
      const color = layer.GetColor();
      if (typeof color === 'string') {
        if (color !== '') {
          args.color = color;
        } else {
          hilight = null;
        }
      }
      if (hilight !== null) {
        args.hilight = hilight;
      }
      args.format = 'json';
      const classes = JSON.stringify(layer.classification);
      args.criteria = classes;
      const src = layer.GetSourceLayer() as SLLayer;
      if (src?.plid) {
        args.player_id = src?.identifier;
      } else {
        args.layer_id = src?.id;
      }

      this.wapi.Post('layers/legend/virtual_swatch/', args).then((result: any) => {
        if (result === undefined) {
          resolve([]);
          return;
        }
        resolve([result.response.legendEntry]);
      }).catch(reject);
    });

  }
  GetLayerLegend(layer: SLLayer, iconWidth: number = 60, iconHeight: number = 21): Promise<any> {
    iconWidth = iconHeight = null;

    return new Promise<any>((resolve, reject) => {
      if (layer.type === LayerTypeEnum.WMS) {
        resolve([]);
        return;
      }
      if (layer.type === LayerTypeEnum.Raster) {
        resolve([]);
        return;
      }

      const args: Decorable = {
        project: layer.map.project.id,
        action: 'list'
      };
      if (layer.isPLayer === true) {
        args.player = layer.plid;
      } else {
        args.layer = layer.id;
      }
      this.wapi.Post('layers/legend', args).then((result: any) => {
        if (result === undefined) {
          resolve([]);
          return;
        }
        if (result.response.legend.classes.length === 0) {
          resolve([]);
        }
        resolve(result.response.legend.classes);
      }).catch(reject);
    });

  }
  MakeOverlayLayer(map: ISLMap, layer: SLLayer): ILayerOverlay {
    return new LayerOverlay(map, layer);
  }

  SearchFeatures(params: SearchParams): CancellablePromise {
    return this.wapi.Post('features/search',
      params, false);
  }
  CSVExport(
    mapId: string,
    searchLayer: SLLayer,
    features: Array<string>,
    type: 'selected' | 'unselected' | 'all' | 'memory',
    geom: boolean = false
  ) {
    geom = null;
    const params: any = {
      format: 'csv',
      mode: 'search',
      idField: 'gid',
      fields: searchLayer.GetExportableAttributes(true).join(','),
      filters: '[{"compare":"IN","value":"' + features.join(',') + '","field":"gid"}]'

    };
    if (searchLayer.isPLayer === true) {
      params.mapId = mapId;
      params.players = searchLayer.plid;
    } else {
      params.layer = searchLayer.id;
    }

    return this.wapi.DownloadFile(
      'features/find',
      params,
      'text/csv',
      searchLayer.name + '-' + type + '.csv'
    );

  }
  FeatureZoom(layer: SLLayer, optFeatures: Array<any> | string = null): CancellablePromise {
    const params: any = {};

    if (layer.isPLayer === true) {
      params.player = layer.identifier;
    } else {
      params.layer = layer.id;
    }
    if (optFeatures !== null) {
      params.gids = (Array.isArray(optFeatures) === true) ?
        (optFeatures as Array<any>).join(',')
        : optFeatures;
    }
    return this.wapi.Post('layers/layer/get_features_extent',
      params, false);
  }

  SaveLayer(layer: SLLayer, options: any, asDefault: boolean = false): CancellablePromise {
    options.target = asDefault ? 'layer' : 'player';
    options.lid = layer.id;

    if (layer.isPLayer) {
      options.plid = layer.plid;
    }
    return this.wapi.Post('layers/layer/update', options);
  }
  PromptSave(handler: AnyHandler, layer: SLLayer) {
    this.saveDialogService.Show(handler, layer);
  }
  PromptLoad(handler: AnyHandler, layer: SLLayer) {
    this.loadDialogService.Show(handler, layer);
  }
  UpdateLayer(layer: SLLayer, saveOptions: LayerSaveOptions): CancellablePromise {
    const params: any = {};
    if (layer.plid !== null) {
      params.plid = layer.plid;
    }
    params.lid = layer.id;

    params.target = saveOptions.target;
    if (saveOptions.properties === true) {
      if (params.target === 'player') {
        params.layer_on = layer.GetLayerVis() ? 1 : 0;
        params.opacity = layer.opacity;
        params.legendary = layer.includeInLegend ? 1 : 0;
        params.labels_on = layer.labelsOn ? 1 : 0;
        if (layer.labelsOn === true) {
          if (layer.labelAttribute !== '_sl_override_') {
            params.labelitem = layer.labelAttribute;
          } else {
            if (layer.labelOverride !== '') {
              params.label = layer.labelOverride;
            } else {
              params.labels_on = 0;
            }
          }
        }
        params.searchable = layer.searchable ? 1 : 0;
        params.tooltip_on = layer.tooltipOn ? 1 : 0;
      }
    }
    if (saveOptions.labelStyle === true) {
      params.label_style = layer.labelStyleJSON;
    }

    if (saveOptions.tooltip_rich === true) {
      params.tooltip_rich = layer.richTooltip;
    }
    if (saveOptions.classification === true) {
      if (saveOptions.target === 'layer') {
        params.classification = 1;
      }
    }
    return this.wapi.Post('layers/layer/update', params);
  }
  LoadLayer(layer: SLLayer, loadOptions: LayerLoadOptions): CancellablePromise {
    let format = 0;
    if (loadOptions.properties) {
      if (loadOptions.target === 'player') {
        format += FormatOpts.PROPERTIES;
      }
    }
    if (loadOptions.labelStyle) {
      format += FormatOpts.LABELS;
    }
    if (loadOptions.tooltip_rich) {
      format += FormatOpts.TOOLTIP_RICH;
    }
    if (!!loadOptions.tooltip) {
      format += FormatOpts.TOOLTIP;
    }
    if (loadOptions.classification) {
      format += FormatOpts.CLASSIFICATION;
    }
    const params: any = {};
    if (layer.plid !== null) {
      params.plid = layer.plid;
    }
    params.lid = layer.id;
    params.target = loadOptions.target;
    params.format_options = format;
    return this.wapi.Post('layers/layer/load', params);

  }
  PromptExport(layer: SLLayer) {
    this.modalMessager.RequestDownload(
      { extension: 'zip', mimeType: 'application/zip', defaultFileName: layer.name + '.zip' },
      'layers/download/shp', { layer: layer.id, fields: layer.GetExportableAttributes(true) }, `Exporting layer ${layer.name} to file the download button will become available when the file is recievied from the server.`,
      () => { }, () => { }, 'Exporting layer to local file.');
  }
  GetSnaps(layer: SLLayer, meterDistance: number | string, pt: LngLat, ptFormat: 'geojson' | 'lnglat' = 'geojson'): CancellablePromise {

    const params: any = {};
    if (layer.plid === layer.identifier) {
      params.plid = layer.plid;
    } else {
      params.lid = layer.id;
    }
    params.distance = meterDistance;
    params.lng = pt?.lng;
    params.lat = pt?.lat;
    params.pt_format = ptFormat;
    return this.wapi.Post('layers/layer/get-snaps', params);

  }
  GetSegSnaps(layer: SLLayer, meterDistance: number | string, pt: LngLat, ptFormat: 'geojson' | 'lnglat' = 'geojson') {
    const params: any = {};
    if (layer.plid === layer.identifier) {
      params.plid = layer.plid;
    } else {
      params.lid = layer.id;
    }
    params.distance = meterDistance;
    params.lng = pt?.lng;
    params.lat = pt?.lat;
    params.pt_format = ptFormat;
    return this.wapi.Post('layers/layer/get-seg-snaps', params);
  }

}
